import React, { useState, useEffect } from 'react';
import { getPageContent, subscribeToPage } from '../firebase/firebase-config';

function SupportStaff() {
  const [content, setContent] = useState({ title: 'Support Staff', supportStaff: [], sliderImages: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try { const data = await getPageContent('supportStaff'); setContent(data); } catch(e) { console.error(e); }
      finally { setLoading(false); }
    };
    loadData();
    const unsubscribe = subscribeToPage('supportStaff', (data) => { if (data) setContent(data); });
    return () => unsubscribe();
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="support-page">
      <div className="container"><h1 className="page-title">{content.title}</h1><div className="staff-grid">{(content.supportStaff || []).map((s, idx) => (<div key={idx} className="staff-card">{s.photo && <img src={s.photo} alt={s.name} />}<h3>{s.name}</h3><p>{s.designation}</p><p className="department">{s.department}</p></div>))}</div></div>
      <style>{`
        .support-page { background: #f8fafc; min-height: 100vh; padding: 60px 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        .page-title { font-size: 36px; color: #1a3a6b; text-align: center; margin-bottom: 40px; }
        .staff-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 30px; }
        .staff-card { background: white; border-radius: 16px; padding: 20px; text-align: center; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
        .staff-card img { width: 100px; height: 100px; border-radius: 50%; object-fit: cover; margin-bottom: 15px; }
        .staff-card h3 { color: #1a3a6b; margin-bottom: 5px; }
        .staff-card .department { color: #f59e0b; font-size: 12px; margin-top: 8px; }
        .loading { display: flex; justify-content: center; align-items: center; min-height: 60vh; }
        .spinner { width: 50px; height: 50px; border: 4px solid #e2e8f0; border-top-color: #1a3a6b; border-radius: 50%; animation: spin 1s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 768px) { .page-title { font-size: 28px; } }
      `}</style>
    </div>
  );
}
export default SupportStaff;